/* jshint undef: true, unused: true */
/* globals globals, AddNewFloatingDiv */

var ContentManagementDisplay = require('../../../../js_functions/form-builder/js/content-management-display-form'),
    FormBuilderStructure = require('./equipment-form-builder-structure'),
    DisplayStructure = require('./equipment-display-structure'),
    equipmentService = require('./equipment-service'),
    listGQL = require('raw-loader!./equipment-list.graphql'),
    uuidWrapper = require('../../../../js_functions/uuid-wrapper'),
    Translation = require('../../../../js_functions/medsEquipmentsTranslation'),
    irmFunctions = require('../irm-shared-functions'),
    equipmentSearchModal = require('./equipmentSearchModal'),
    equipsRESTService = require('./equipment-rest-service');

var GQLURI = 'https://dev1.private.dev.datixcloudiq.co.uk/iris/q',
    uidPrefix = 'equipment',
    tableOptions,
    formStructure,
    contentTable,
    translations = new Translation('devices'),
    clearEquipmentFields,
    submitRecord,
    onEquipmentSubmissionSuccessCallback,
    onEquipmentErrorSubmissionCallback,
    searchModal;

function restructureExistingData(data) {
  const restructuredValues = [];

  data.forEach(function (row, i) {

    restructuredValues[i] = {};

    row.answers.forEach(function (answer) {
      restructuredValues[i][answer.questionId] = answer.answer[0];
    });

    restructuredValues[i].recordId  = row.recordId;
    restructuredValues[i].answersId = row.id;
  });

  return restructuredValues;
}

function initInputWithButton(targetInput, targetInputAddonElement, foBu) {
  targetInput.foBu = foBu;
  irmFunctions.initInputWithButton(targetInput, targetInputAddonElement);
}

function globalDateFormat()
{
  return globals.dateFormat;
}

function instantiateDeleteEquipmentDialogue(event) {
  event.stopPropagation();
  event.preventDefault();
  var id      = 'inc-equipment--add-equipment-dialog__cancel',
      title   = translations.translateString('DEVICES.V2.FORM.MESSAGE.DELETE.TITLE'),
      content = translations.translateString('DEVICES.V2.FORM.MESSAGE.DELETE.CONTENT'),
      modal   = AddNewFloatingDiv(id),
      recordId   = event.target.dataset.recordId;

  modal.setTitle(title);
  modal.setContents('<div>' + content + '</div>');

  modal.setSizeModify({'width': 300});

  modal.setButtons([
    {
      value   : translations.translateString('DEVICES.V2.FORM.BUTTON.DELETE.CANCEL'),
      onclick : function() {
        modal.CloseFloatingControl();
      }
    },
    {
      value   : translations.translateString('DEVICES.V2.FORM.BUTTON.DELETE.OK'),
      class   : 'button-warning',
      onclick : function() {
        const cmt       = this;
        const answersId = event.target.dataset.answersId;

        modal.CloseFloatingControl();
        window.displayLoadPopup();
        equipmentService
          .deleteAnswer(answersId)
          .then(function () {
            window.hideLoadPopup();
            cmt.deleteRecord(recordId);
            irmFunctions.showMessage(translations.translateString('DEVICES.SUCCESSFULLY_DELETED'));
          }).catch(e => {
            window.hideLoadPopup();
            irmFunctions.showMessage(checkForErrorString(e), 'error');
          });
      }.bind(this)
    }
  ]);

  modal.display();

  return modal;
}

clearEquipmentFields = function(event) {
  event.stopPropagation();
  event.preventDefault();
  var foBu   = this,
      fields = foBu.formElement.getElementsByClassName(
        'equipment-field'
      );

  // can clear if theres no attributes or donotclear is not set
  const canClear = attributes => !attributes || !attributes.donotclear;
  // REFACTOR SUGGESTION: Call clearFields from irm-shared-functions.js
  // clearFields should be moved there from medicationForm.js
  Array.from(fields).forEach(field => {
    if(canClear(field.attributes)) {
      foBu.clearField(field.foBuSettings);
    }
  });
};

// REFACTOR SUGGESTION: Move to irm-shared-functions.js
// There is litte difference between this and the one in medicationForm.js so it should be possible to abstract it
submitRecord = function(values, wasEdited = false) {
  var formUid          = tableOptions.uid,
      answerUuid       = values.answersId,
      recordUuid = globals.recordUuid,
      excludeFields    = ['dataViewRecordIndex', 'answersId', 'equipmentSearch'],
      answers          = [],
      successCallback  = (data, params) => onEquipmentSubmissionSuccessCallback(data, params, wasEdited),
      errorCallback    = onEquipmentErrorSubmissionCallback,
      isValueSet       = function(value) {
        if (value === 'undefined' || typeof value === 'undefined' || value === '') {
          return false;
        }
        return true;
      };

  if (!isValueSet(answerUuid)) {
    answerUuid = uuidWrapper();
  }
  if (!isValueSet(recordUuid)) {
    recordUuid = uuidWrapper();
  }

  Object.keys(values).forEach(function (key) {
    var value = values[key];
    if (!excludeFields.includes(key)) {
      answers.push({
        id         : answerUuid,
        questionId : key,
        answer     : value
      });
    }
  });

  return equipmentService.submitEquipment(formUid, answers, answerUuid, recordUuid, values, successCallback, errorCallback);
};

onEquipmentSubmissionSuccessCallback = function(data, params, wasEdited) {
  const answersId           = data.data.SaveListOfEquipmentAnswers[0].id;
  const dataViewRecordIndex = params.dataViewRecordIndex;
  const editButton          = document.getElementById('edit-row-bottom_equipment-cmt-data-display-row_' + dataViewRecordIndex);
  const deleteButton        = document.getElementById('delete-row-bottom_equipment-cmt-data-display-row_' + dataViewRecordIndex);

  editButton && editButton.setAttribute('data-answers-id', answersId);
  deleteButton && deleteButton.setAttribute('data-answers-id', answersId);

  let message;
  if(wasEdited) {
    message = params.brandName + ' ' + translations.translateString('DEVICES.V2.FORM.MESSAGE.SUCCESSFUL_UPDATE');
  } else{
    message = params.brandName + ' ' + translations.translateString('DEVICES.V2.FORM.MESSAGE.SUCCESSFUL_ADD');
  }
  irmFunctions.showMessage(message);
};

// REFACTOR SUGGESTION: Move to irm-shared-functions.js
onEquipmentErrorSubmissionCallback = function(error) {
  window.hideLoadPopup();
  irmFunctions.showMessage(checkForErrorString(error), 'error');
};

// REFACTOR SUGGESTION: Move to irm-shared-functions.js
// Pass language strings in as parameters
function instantiateCancelFormDialogue(event, isEdited) {
  event.stopPropagation();
  event.preventDefault();

  var id      = 'inc-medications--add-medication-dialog__cancel',
      title   = translations.translateString('DEVICES.V2.FORM.MESSAGE.CANCEL.TITLE'),
      content = translations.translateString('DEVICES.V2.FORM.MESSAGE.CANCEL.CONTENT'),
      modal   = AddNewFloatingDiv(id);

  modal.setTitle(title);
  modal.setContents('<div>' + content + '</div>');

  modal.setSizeModify({'width': 300});

  modal.setButtons([
    {
      value   : translations.translateString('DEVICES.V2.FORM.BUTTON.CANCEL.CANCEL'),
      onclick : modal.CloseFloatingControl.bind(modal)
    },
    {
      value   : translations.translateString('DEVICES.V2.FORM.BUTTON.CANCEL.OK'),
      class   : 'button-primary',
      onclick : function() {
        modal.CloseFloatingControl();
        contentTable.closeForm(isEdited);
      }.bind(this)
    }
  ]);

  modal.display();

  return modal;
}

function checkForErrorString(error) {
  if(!error || (typeof error !== 'string' && !error.responseText)) {
    return 'There was an error with the equipments service.';
  }
  return error;
}

formStructure = {
  class : FormBuilderStructure,
  data  : {
    initInputWithButton       : initInputWithButton,
    GQLURI                    : GQLURI,
    GQLQuery                  : listGQL,
    globalDateFormat          : globalDateFormat,
    errorCallback             : onEquipmentErrorSubmissionCallback,
  }
};

function initialise() {
  tableOptions = {
    isEditable       : irmFunctions.isEditable,
    uid              : uidPrefix + '-cmt-data-display',
    formType         : 'Equipment',
    formTypeTextKey  : 'equipment',
    displayStriping  : 'even',
    newButtonClasses : {
      buttonIds : ['new-Equipment-button-top', 'new-Equipment-button-bottom'],
      class    : 'cmt--hidden'
    },
    contentDisplaySettings : {
      formAttributes : {
        class : uidPrefix + '-cmt__data-display-form'
      },
      inputClass          : 'form-control',
      inputLayoutClass    : 'col-12',
      labelClass          : 'col-12',
      structure         : new DisplayStructure(),
      isRecordDisplay   : true,
      callableFunctions : {
        deleteButtonAction : instantiateDeleteEquipmentDialogue
      }
    },
    contentClass: {
      options          : {
        uid               : uidPrefix + 'form',
        formModuleName    : function() { return translations.translateString('DEVICES.PLURAL'); },
        formType          : 'Equipment',
        formTypeTextKey   : 'equipment',
        formAttributes    : {},
        inputClass        : 'form-control',
        inputLayoutClass  : 'col-12',
        labelClass        : 'col-12',
        structure         : new formStructure.class(formStructure.data),
        callableFunctions : {
          clearEquipmentFields: clearEquipmentFields,
          cancelButtonAction : instantiateCancelFormDialogue
        },
        submitRecord: submitRecord
      }
    }
  };
}

function getEquipmentSearchResultsModal(searchTerm, searchField)
{
  const equipmentAPIService = globals.equipmentV2Enabled ? equipsRESTService : equipmentService;

  window.displayLoadPopup();
  // Get search data. Open modal.
  equipmentAPIService
    .getEquipmentSearchResults(searchTerm, searchField)
    .then(function (response) {
      const equipmentBrands = globals.equipmentV2Enabled ? response : response.data.RequestListOfEquipment;
      equipmentSearchModal(equipmentBrands, equipmentAPIService)
        .then(modal => {
          searchModal = modal;
        });
    })
    .catch(e => {
      data.errorCallback(e);
    });
}

module.exports = function (id, renderForm, callback) {
  const options = {
    uuid: uuidWrapper,
    deleteEquipment: equipmentService.deleteAnswer
  };

  initialise();

  if (renderForm === undefined) {
    renderForm = true;
  }

  if (callback !== undefined) {
    globals.recordUuid = callback(tableOptions, options);
    options.contentTable = contentTable;
  }

  // If Equipments is intended to run, it requires loading some resources.
  return new Promise(function (resolve, reject) {

    const buildContentTableParams = {
      tableOptions               : tableOptions,
      translations               : translations,
      cmdClass                   : ContentManagementDisplay
    };

    translations.getTranslations()
      .then(function() {
        if (renderForm) {
          // If the record is new and has no errors don't load existing equipment data
          if (globals.isNewRecord === true && globals.isNewRecordWithErrors === false) {
            contentTable = irmFunctions.buildContentTable(id, buildContentTableParams);
            options.contentTable = contentTable;
            resolve(contentTable);
          } else {
            equipmentService
              .queryAnswers(globals.recordUuid)
              .then(function(data) {
                buildContentTableParams.existingFormData = restructureExistingData(data.data.RequestListOfEquipmentAnswers || []);
                contentTable = irmFunctions.buildContentTable(id, buildContentTableParams);
                options.contentTable = contentTable;
                resolve(contentTable);
              })
              .catch(reject);
          }
        }
      }, reject);
  });
};

// Exposing functionality outside of webpack, for use with PHP-based equipment forms
window.getEquipmentSearchResultsModal = getEquipmentSearchResultsModal;
window.closeEquipmentSearchModal = function()
{
  if (searchModal) {
    searchModal.CloseFloatingControl();
  }
};
